export default __webpack_public_path__ + "static/media/upgrade-feature.3a533a2e.svg";